<template>
  <v-menu
    offset-y
    v-model="showMenu"
    close-on-click
    nudge-bottom="5"
  >
    <template v-slot:activator="{ on }">
      <component
        :is="objectLink && hasAnyPermission('OBJECT_VIEW_DETAILS') ? 'router-link' : 'placeholder-component'"
        v-on="on"
        :to="objectLink"
        :target="openInNewTab ? '_blank' : '_self'"
        class="object-name"
        :title="getLinkTitle(displayName)"
        @contextmenu.native.prevent.stop="openMenu"
      >
        {{ displayName }}
        <v-icon
          v-if="canOpenInStayin"
          class="more-icon"
          style="opacity: 0;"
          size="16"
          @click.prevent.stop="openInStayin"
          color="primary"
          :title="trans('general.openInStayin')"
        >mdi-open-in-new</v-icon>
      </component>
    </template>
    <open-in-stayin-menu @open-in-stayin="openInStayin" />
  </v-menu>
</template>

<script>
import {MainUtils} from '../utils/main-utils';
import ConfigReader from '@/lib/config-reader';
import {LocaleUtils} from '@/utils/locale-utils';
import {OpenInStayinUtils} from '@/utils/open-in-stayin-utils';
import OpenInStayinMenu from '@/components/OpenInStayinMenu';
import PlaceholderComponent from '@/components/PlaceholderComponent';

export default {
  name: 'ObjectName',
  components: {
    OpenInStayinMenu,
    PlaceholderComponent
  },
  mixins: [
    MainUtils,
    LocaleUtils,
    OpenInStayinUtils
  ],
  props: {
    value: {
      required: true
    },
    openInNewTab: {
      default () {
        return true;
      }
    }
  },
  computed: {
    isObjectProvided() {
      return this.value != null && typeof this.value === 'object';
    },
    displayName() {
      return this.isObjectProvided ? (this.value.objectName ?? this.value.name) : this.value;
    },
    objectId() {
      return this.isObjectProvided ? (this.value.objectId ?? this.value.id) : null;
    },
    objectLink() {
      if(this.objectId == null) {
        return null;
      }

      return {
        name: 'ObjectPage',
        params: {
          objectId: this.objectId
        }
      }
    }
  },
  methods: {
    openInStayin () {
      const stayinUrlObjectDetails = ConfigReader.value('stayinUrlObjectDetails');
      if (!stayinUrlObjectDetails) {
        return;
      }
      window.open(stayinUrlObjectDetails.replace('{objectId}', this.value.id), '_blank');
    }
  }
}
</script>

<style scoped>
.object-name {
  display: inline-block;
}

.object-name:hover .more-icon {
  opacity: 1 !important;
}
</style>
